import { render, staticRenderFns } from "./RestaurantDefault.vue?vue&type=template&id=6ff47ee6&scoped=true&"
import script from "./RestaurantDefault.vue?vue&type=script&lang=js&"
export * from "./RestaurantDefault.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDefault.vue?vue&type=style&index=0&id=6ff47ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff47ee6",
  null
  
)

export default component.exports